import { epicRequest } from 'app'

import { tournamentLastViewed } from 'actions/AuthActions'

import { tournamentRelationFetch } from './relation'

export const TOURNAMENT_PAGE_FETCH = 'TOURNAMENT_PAGE_FETCH'
export const TOURNAMENT_PAGE_FETCH_ERROR = 'TOURNAMENT_PAGE_FETCH_ERROR'
export const TOURNAMENT_PAGE_FETCH_FULFILLED = 'TOURNAMENT_PAGE_FETCH_FULFILLED'
export const TOURNAMENT_PAGE_FETCH_CANCELED = 'TOURNAMENT_PAGE_FETCH_CANCELED'

export const tournamentPageFetch = (tournamentId) => ({
  payload: tournamentId,
  type: TOURNAMENT_PAGE_FETCH,
})

export const tournamentPageFetchFulfilled = (payload) => ({
  payload,
  type: TOURNAMENT_PAGE_FETCH_FULFILLED,
})

export const tournamentPageFetchCanceled = () => ({
  payload: null,
  type: TOURNAMENT_PAGE_FETCH_CANCELED,
})

export const tournamentPageFetchError = (payload) => ({
  payload,
  type: TOURNAMENT_PAGE_FETCH_ERROR,
})

export const tournamentPageFetchEpic = epicRequest({
  actionType: TOURNAMENT_PAGE_FETCH,
  errorAction: tournamentPageFetchError,
  fulfilledAction: tournamentPageFetchFulfilled,
  maps: [
    (_response, { payload }) => tournamentLastViewed(payload),
    (_response, { payload }) => tournamentRelationFetch(payload),
  ],
  request: ({ payload }) => `sports/tournament/${payload}`,
  untilTypes: TOURNAMENT_PAGE_FETCH_CANCELED,
})
